/**
 * services/overview/overview.service.ts
 * The Finance Overview in one call — KPIs, charts, needs-attention and gates,
 * all sharing a single as-of moment.
 */
import axiosInstance from '../../api/axiosInstance';
import { Cash_Overview_Url } from '../../api/endpoints';
import { parseResponse } from '../../schemas/common';
import { overviewSchema, type Overview } from '../../schemas/overview';

export async function fetchOverview(): Promise<Overview> {
  const { data } = await axiosInstance.get(Cash_Overview_Url);
  return parseResponse(overviewSchema, data, 'GET /v1/overview');
}

export type { Overview };
